import Vue from 'vue';

export default {
    getJobTitleSuggestion(context, keyword) {
        const url = `v1/job-title?keyword=${keyword}`;
        return Vue.$axios.$get(url);
    },

    getJob(context, { jobUuid, createToken }) {
        const url = `v1/jobs/${jobUuid}?create_token=${createToken ? 1 : 0}`;
        return Vue.$axios.get(url).then((response) => {
            if (response.data.data) {
                const jobPayload = {
                    ...response.data.data,
                    is_expired: false,
                };
                context.commit('STORE_JOB', jobPayload);
            }
            return response;
        });
    },

    getJobApplyUrl(context, jobUuid) {
        const url = `v1/jobs-apply-url/${jobUuid}`;
        return Vue.$axios.get(url);
    },

    getMatchedJobs(context, matchJobFilter) {
        const url = '/v1/match';
        return Vue.$axios.$post(url, matchJobFilter);
    },

    getExpiredJobs(context, jobUuid) {
        const url = `v1/expired-jobs/${jobUuid}`;
        return Vue.$axios.get(url).then((response) => {
            if (response.data.data) {
                const jobPayload = {
                    ...response.data.data,
                    is_expired: true,
                };
                context.commit('STORE_JOB', jobPayload);
            }
            return response;
        });
    },

    getScreeningQuestions(context, jobUuid) {
        const url = `v1/jobs/${jobUuid}/screen-questions`;
        return Vue.$axios.$get(url);
    },

    saveScreeningQuestionResponses(context, { jobUuid, formData }) {
        const url = `v1/jobs/${jobUuid}/screen-questions`;
        let data = new FormData();

        formData.forEach((element, idx) => {
            Object.entries(element).forEach((item) => {
                if (item[1]) {
                    if (Array.isArray(item[1])) {
                        item[1].forEach((vo, vi) => {
                            if (vo) {
                                data.append(`data[${idx}][${item[0]}][${vi}]`, vo);
                            }
                        });
                    } else {
                        if (item[1]) {
                            data.append(`data[${idx}][${item[0]}]`, item[1]);
                        }
                    }
                }
            });
        });

        return Vue.$axios.$post(url, data);
    },

    getScreeningQuestionSet(context, jobUuid){
        const url = `v1/jobs/${jobUuid}/screen-question-set`;
        return Vue.$axios.$get(url);
    },
};